import { render, staticRenderFns } from "./BestenlisteUebersicht.vue?vue&type=template&id=50e6279f&scoped=true&"
import script from "./BestenlisteUebersicht.vue?vue&type=script&lang=js&"
export * from "./BestenlisteUebersicht.vue?vue&type=script&lang=js&"
import style0 from "./BestenlisteUebersicht.vue?vue&type=style&index=0&id=50e6279f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e6279f",
  null
  
)

export default component.exports